import { useState } from 'react';
import { Ic } from './Icon';
import { SectionHead, delay } from './Section';
import type { LandingContent } from './content';

export function FaqSection({ c }: { c: LandingContent }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="lp-section" id="faq" style={{ paddingTop: 0 }}>
      <div className="lp-container">
        <SectionHead eyebrow={c.faq.eyebrow} title={c.faq.title} />
        <div className="faq">
          {c.faq.items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div className={`faq-item${isOpen ? ' open' : ''}`} data-reveal key={f.q} style={delay(i * 50)}>
                <button type="button" className="faq-q" aria-expanded={isOpen} aria-controls={`faq-a-${i}`} onClick={() => setOpen(isOpen ? null : i)}>
                  <span>{f.q}</span>
                  <Ic name="chev" />
                </button>
                <div className="faq-a" id={`faq-a-${i}`} role="region">
                  <div>
                    <p>{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
